import { render, staticRenderFns } from "./AssetReviewerDialog.vue?vue&type=template&id=16d10706&scoped=true"
import script from "./AssetReviewerDialog.vue?vue&type=script&lang=js"
export * from "./AssetReviewerDialog.vue?vue&type=script&lang=js"
import style0 from "./AssetReviewerDialog.vue?vue&type=style&index=0&id=16d10706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d10706",
  null
  
)

export default component.exports